module.exports = __webpack_public_path__ + "static/media/user.e4a38cff.jpg";